module.exports = __webpack_public_path__ + "static/Select-Repairer-b9b5167a873bbb3a4e248eea4742af84.svg";